export default "__VITE_ASSET__CznM5NYR__"